<template>
  <div class="layout-container-vertical">
    <ht-nav-bar />

    <div class="app-main">
      <ht-side-bar />

      <ht-app-main />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VerticalLayout',
  }
</script>

<style lang="scss" scoped>
  .layout-container-vertical {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .app-main {
      display: flex;
      flex: 1;
      flex-direction: row;
      overflow: hidden;
      transition: $base-transition;
      /*火狐下隐藏滚动条*/
      scrollbar-width: none;

      //隐藏滚动条
      &::-webkit-scrollbar {
        width: 0;
        background-color: transparent;
      }

      ::v-deep {
        .app-main-container {
          box-sizing: border-box;
          width: calc(100% - #{$base-content-margin}* 2);
          height: calc(100% - #{$base-content-margin}* 2);
          margin: $base-content-margin;
          overflow-y: auto;
          background-color: $base-color-white;
          border-radius: $base-border-radius;

          /*火狐下隐藏滚动条*/
          scrollbar-width: none;

          //隐藏滚动条
          &::-webkit-scrollbar {
            width: 0;
            background-color: transparent;
          }

          .base-main {
            background-color: #f9fafc;
          }
        }
      }
    }
  }
</style>
